
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PhoneCall, Mail } from "lucide-react";

const ContactCTA: React.FC = () => {
  return (
    <div className="bg-fabre-beige rounded-lg p-6 shadow-sm mt-8">
      <h3 className="text-xl font-heading font-bold mb-4 text-fabre-gray">
        Besoin d'une solution personnalisée ?
      </h3>
      
      <p className="text-gray-600 mb-6">
        Notre équipe d'experts est à votre disposition pour vous proposer une solution adaptée à vos besoins spécifiques. Contactez-nous dès aujourd'hui.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
          <Link to="/contact">
            <Mail className="mr-2 h-4 w-4" />
            Demander un devis
          </Link>
        </Button>
        
        <Button variant="outline" asChild className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen">
          <a href="tel:0565678205">
            <PhoneCall className="mr-2 h-4 w-4" />
            05.65.67.82.05
          </a>
        </Button>
      </div>
    </div>
  );
};

export default ContactCTA;
